import { adminFetch } from "./_client";
import type { ConnectionStatus, SchemaDiffResult, MigrationRecord, ExecutionResult, VerificationReport, CodeDriftReport, SnapshotRecord, OneClickResult, SnapshotContent } from "./types";


export function fetchConnectionStatus(token: string) {
  return adminFetch<ConnectionStatus>("/admin/schema-push/connection-status", token);
}


export function fetchSchemaComparison(token: string) {
  return adminFetch<SchemaDiffResult>("/admin/schema-push/compare", token);
}


export function fetchCodeSchemaDrift(token: string) {
  return adminFetch<CodeDriftReport>("/admin/schema-push/code-drift", token);
}


export function generateMigration(token: string, description: string) {
  return adminFetch<{ migration: MigrationRecord; confirmationToken: string }>("/admin/schema-push/generate-migration", token, {
    method: "POST",
    body: JSON.stringify({ description }),
  });
}


export function executeSchemaOnProd(token: string, confirmationToken: string, confirmText: string) {
  return adminFetch<{ result: ExecutionResult; verification: VerificationReport | null }>("/admin/schema-push/execute", token, {
    method: "POST",
    body: JSON.stringify({ confirmationToken, confirmText }),
  });
}


export function fetchMigrationHistory(token: string) {
  return adminFetch<{ history: MigrationRecord[] }>("/admin/schema-push/history", token);
}


export function fetchSchemaVerification(token: string) {
  return adminFetch<VerificationReport>("/admin/schema-push/verify", token);
}


export function oneClickPush(token: string) {
  return adminFetch<OneClickResult>("/admin/schema-push/one-click", token, { method: "POST" });
}


export function fetchCooldown(token: string) {
  return adminFetch<{ cooldownSeconds: number }>("/admin/schema-push/cooldown", token);
}


export function fetchSnapshots(token: string) {
  return adminFetch<{ snapshots: SnapshotRecord[] }>("/admin/schema-push/snapshots", token);
}


export function createSnapshot(token: string) {
  return adminFetch<{ snapshot: SnapshotRecord }>("/admin/schema-push/snapshot", token, { method: "POST" });
}


export function rollbackMigration(token: string, migrationFilename: string) {
  return adminFetch<{ snapshot: SnapshotRecord; execution: ExecutionResult }>("/admin/schema-push/rollback", token, {
    method: "POST",
    body: JSON.stringify({ migrationFilename }),
  });
}


export function fetchChangelog(token: string) {
  return adminFetch<{ content: string }>("/admin/schema-push/changelog", token);
}


export function fetchSnapshotContent(token: string, filename: string) {
  return adminFetch<SnapshotContent>(`/admin/schema-push/snapshots/${encodeURIComponent(filename)}`, token);
}
